import React, { Component, ReactNode, Fragment } from "react";
import DashboardHeader from "components/DashboardHeader";
import "./index.scss";
import { Button } from "@material-ui/core";
import RouteURLs from "RouteURLs";
import { RouteComponentProps, withRouter } from "react-router";
import DefaultLayout from "layouts/Default";

export interface BookingLayoutProps extends RouteComponentProps {
  id?: string;
  children: ReactNode;
  className?: string;
  footerChildren?: ReactNode;
}

class BookingLayout extends Component<BookingLayoutProps> {
  onDashboardClick = () => {
    this.props.history.push(RouteURLs.DASHBOARD);
  };

  renderHeader() {
    const navItems = [
      { title: "Dashboard", route: RouteURLs.DASHBOARD },
      { title: "Designs", route: RouteURLs.DESIGN_LIST },
    ];
    return (
      <DashboardHeader navItems={navItems}>
        <Button onClick={this.onDashboardClick}>My Dashboard</Button>
      </DashboardHeader>
    );
  }

  renderFooter() {
    return this.props.footerChildren || <Fragment />;
  }

  render() {
    const className = this.props.className
      ? `${this.props.className} booking-layout`
      : "booking-layout";
    return (
      <DefaultLayout
        className={className}
        id={this.props.id}
        header={this.renderHeader()}
        footer={this.renderFooter()}
      >
        {this.props.children}
      </DefaultLayout>
    );
  }
}

export default withRouter(BookingLayout);
